// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7D8Kb","buttons":"styles_buttons__1h1Me"};